import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "flagFilled"
const FlagFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.073 1.698C19.45 1.76 19.87 2.024 20.005 2.53 20.855 5.761 21.72 8.99 22.585 12.218 22.689 12.598 22.64 13.035 22.399 13.397 21.394 14.895 19.95 15.398 18.423 15.476 16.953 15.55 15.28 15.234 13.75 15.015 12.16 14.788 10.67 14.653 9.343 14.968 8.135 15.254 7.025 15.923 6.115 17.366L7.029 20.795 7.324 21.905 7.404 22.202 7.43 22.307C7.537 22.707 7.3 23.117 6.9 23.224S6.089 23.093 5.982 22.693L5.954 22.589 5.874 22.29 5.58 21.182 4.584 17.443C3.695 14.105 2.574 9.9 1.824 7.096 1.672 6.528 1.739 5.882 2.102 5.351 3.256 3.663 4.718 2.841 6.299 2.522 7.839 2.212 9.47 2.382 10.974 2.604 12.527 2.832 13.91 3.106 15.155 3.1 16.366 3.095 17.284 2.82 17.957 2.078 18.263 1.74 18.703 1.636 19.073 1.698" />
        </svg>
      }
    </span>
  )
}
export default FlagFilledIcon
